import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'dateShortFr' })
export class DateShortFrPipe implements PipeTransform {
  /** Expected format: DDMMYY */
  transform(value: string | null | undefined): string {
    if (value === '000000') return '';
    if (!value || value.length !== 6 ) return value ?? '';
    const day = value.slice(0, 2);
    const month = value.slice(2, 4);
    const year = value.slice(4, 6);
    return `${day}/${month}/${year}`;
  }
}